/** @format */
import HostNode from './icon/host.png'
import SwitchNode from './icon/switch.png'
import GatewayNode from './icon/gateway.png'
import RouterNode from './icon/router.png'
import HostNodeHover from './icon/host_hover.png'
import SwitchNodeHover from './icon/switch_hover.png'
import GatewayNodeHover from './icon/gateway_hover.png'
import RouterNodeHover from './icon/router_hover.png'
import HostNodeActive from './icon/host_click.png'
import SwitchNodeActive from './icon/switch_click.png'
import GatewayNodeActive from './icon/gateway_click.png'
import RouterNodeActive from './icon/router_click.png'
import lodash from 'lodash'

// 设备告警、链路分析颜色
export const alarmColor = {
  Info: '#36B42A',
  Warning: '#FFAE3D',
  Minor: '#FFA8A0',
  Critical: '#FF4433'
}
// 设备告警、链路分析中文
export const alarmTitle = {
  Info: '正常',
  Warning: '警告',
  Minor: '错误',
  Critical: '严重'
}

// 数据源、设备 Form数据
export interface HeaderFormValues {
  dataSource: string
  device: string[]
}
export const initHeaderFormValues: HeaderFormValues = {
  dataSource: undefined,
  device: []
}

// 链路分析开关、显示名称
export interface AnalysisFormValues {
  analysisSwitch: boolean
  showName: 'SystemName' | 'GUID' | 'IP'
  layout: 'level' | 'disperse'
}

export const initAnalysisFormValues: AnalysisFormValues = {
  analysisSwitch: false,
  showName: 'SystemName',
  layout: 'level'
}

// 链路分析默认值
export interface AnalysisConfig {
  Metric: string
  Compare: '>' | '<' | '='
  Normal: string
  Warn: string
  Error: string
  Serious: string
}

// 监控项
export interface MetricObject {
  Metric: string
  Units: string
  MetricDesc: string
}

// 链路信息table
export const edgeTabelData = [
  {
    name: '系统GUID',
    source: '',
    desination: ''
  },
  {
    name: '设备系统名称',
    source: '',
    desination: ''
  },
  {
    name: '端口',
    source: '',
    desination: ''
  },
  {
    name: 'MTU',
    source: '',
    desination: ''
  },
  {
    name: '带宽',
    source: '',
    desination: ''
  },
  {
    name: '速度',
    source: '',
    desination: ''
  },
  {
    name: 'Port RX Data',
    source: '',
    desination: ''
  },
  {
    name: 'Port TX Data',
    source: '',
    desination: ''
  },
  {
    name: 'Port RX Data Rate',
    source: '',
    desination: ''
  },
  {
    name: 'Port TX Data Rate',
    source: '',
    desination: ''
  },
  {
    name: 'Port RX Packets',
    source: '',
    desination: ''
  },
  {
    name: 'Port RX Packet Rate',
    source: '',
    desination: ''
  },
  {
    name: 'Port TX Packets',
    source: '',
    desination: ''
  },
  {
    name: 'Port TX Packet Rate',
    source: '',
    desination: ''
  }
  // {
  //   name: 'Normalized Congestion BW',
  //   source: '',
  //   desination: ''
  // },
  // {
  //   name: 'Normalized TX Data',
  //   source: '',
  //   desination: ''
  // }
]

// 节点类型对应图标
export const nodeImg = {
  host: HostNode,
  switch: SwitchNode,
  gateway: GatewayNode,
  router: RouterNode
}
export const nodeHoverImg = {
  host: HostNodeHover,
  switch: SwitchNodeHover,
  gateway: GatewayNodeHover,
  router: RouterNodeHover
}
export const nodeActiveImg = {
  host: HostNodeActive,
  switch: SwitchNodeActive,
  gateway: GatewayNodeActive,
  router: RouterNodeActive
}

// 获取链路分析颜色
export const handleLinkColor = (links, configs) => {
  let level = 99
  configs.forEach(config => {
    if (level === 0) return
    const { Metric, Compare, Normal, Warn, Error, Serious } = config
    links.forEach(link => {
      const { DestinationPortCounters, SourcePortCounters } = link.MonitoringCounters
      const findIndex = [Serious, Error, Warn, Normal].findIndex(value => {
        if (value) {
          switch (Compare) {
            case '>':
              return (
                DestinationPortCounters[Metric] > parseFloat(value) ||
                SourcePortCounters[Metric] > parseFloat(value)
              )
            case '<':
              return (
                DestinationPortCounters[Metric] < parseFloat(value) ||
                SourcePortCounters[Metric] < parseFloat(value)
              )
            case '=':
              return (
                DestinationPortCounters[Metric] === parseFloat(value) ||
                SourcePortCounters[Metric] === parseFloat(value)
              )
            default:
              return false
          }
        } else {
          return false
        }
      })
      if (findIndex < level && findIndex >= 0) {
        level = findIndex
      }
    })
  })
  if (level >= 0) {
    const colors = Object.values(alarmColor).reverse()
    return colors[level] || '#3A3A3A'
  }
  return ''
}

// 链路数据单位转换
export const unitFormat = ['MB', 'MB/s']
export const handleValueUnit = (value, unit) => {
  if (typeof value !== 'number') {
    return value
  }
  if (unitFormat.includes(unit)) {
    const num = (value * 8) / 1000
    const sIndex = unit.includes('/s')
    return `${Math.round(num * 100) / 100} Gb${sIndex ? '/s' : ''}`
  } else {
    return `${Math.round(value * 100) / 100} ${unit}`
  }
}

// 分层展示
export const handelNodeLevel = (allnodes, alledges) => {
  const guids: { [key: string]: number } = {}
  allnodes.forEach(item => {
    if (item.Type === 'host') {
      guids[item.GUID] = 1
    }
  })
  /**
   *
   * @param nodes 设备ID
   * @param level 层级
   */
  const setSwitchLevel = (nodes: string[], level: number) => {
    const node_guid = []
    nodes.forEach(node => {
      // 当前设备直联的设备
      alledges.forEach(edge => {
        const [source, target] = edge.edge_id.split('===')
        if (node === source) {
          if (guids[target]) {
            if (level < guids[target]) {
              guids[target] = level
            }
          } else {
            node_guid.push(target)
            guids[target] = level
          }
        } else if (node === target) {
          if (guids[source]) {
            if (level < guids[source]) {
              guids[source] = level
            }
          } else {
            node_guid.push(source)
            guids[source] = level
          }
        }
      })
    })
    !!node_guid?.length && setSwitchLevel(node_guid, level + 1)
  }
  setSwitchLevel(Object.keys(guids), 2)
  const result = Object.keys(guids)
    .map(key => {
      const find = lodash.find(allnodes, node => node.GUID === key)
      return find ? { ...find, y_level: guids[key] } : undefined
    })
    .filter(item => !!item)
  return result
}
